export enum Country {
  AUS = 'au',
  USA = 'us'
}

export enum CountryFullName {
  AUS = 'Australia',
  USA = 'United States'
}

export const CountryNameMap = {
  [Country.AUS]: CountryFullName.AUS,
  [Country.USA]: CountryFullName.USA
}

export enum CountryPhoneCode {
  AUS = '61',
  USA = '1'
}

export const CountryPhoneCodeMap = {
  [Country.AUS]: CountryPhoneCode.AUS,
  [Country.USA]: CountryPhoneCode.USA
}

export enum CountryId {
  AUS = 1,
  USA = 2
}

export const CountryIdMap = {
  [Country.AUS]: CountryId.AUS,
  [Country.USA]: CountryId.USA
}
